<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">挪车服务</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="move_car">
      <div class="movecar_desc">
        <a :href="'tel:' + 114">
          <div class="callbutton">拨打114(百事通挪车)</div>
        </a>
        <a :href="'tel:' + 122">
          <div class="callbutton1">拨打122(报警服务)</div>
        </a>
        <div class="move_car_shuoming">
          <div class="move_car_title">
            <img class="move_car_tipimg" src="/static/newprojecticon/title.png" />
            <div class="move_car_tiptitle">挪车指引</div>
          </div>
          <div class="move_car_tipp">1:拨打114号码百事通挪车;</div>
          <div class="move_car_tipp">2:拨打122报警服务台要求挪车;</div>
          <div class="move_car_tipp">3:使用交警12123 APP一键挪车服务;</div>
        </div>
      </div>
      <!--    <div class="move_car_shuoming">
      <div class="move_car_title">挪车指引</div>
      <div class="move_car_tipp">1:拨打<a :href="'tel:' + 114">114</a>号码百事通挪车;</div>
      <div class="move_car_tipp">2:拨打<a :href="'tel:' + 122">122</a>报警服务台要求挪车;</div>
      <div class="move_car_tipp">3:使用交警12123 APP一键挪车服务;</div>
    </div> -->
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
    }
  }
</script>

<style scoped>
  /*   body{
    width: 100%;
    height: 100%;

  } */
  * {
    margin: 0;
  /*  padding: 0; */
  }

  a {
    text-decoration: none;
    color: #fff;
    font-size: 14px;
  }

  .move_car {
    width: 100%;
    background-image: url(../../../static/newprojecticon/nuochebg.png);
    background-size: 100% 100%;
    height: 100%;
    position: absolute;
    top: 50px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
  }

  .movecar_desc {
    width: 90%;
    margin: 0 20px;
    position: absolute;
    top: 42%;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
  }

  .callbutton {
    width: 90%;
    margin: 20px;
    height: 46px;
    background: #FD8C00;
    box-shadow: 0 5px 7px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    color: #fff;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .callbutton1 {
    width: 90%;
    margin: 20px;
    height: 46px;
    background:  #FD8C00;
    box-shadow: 0 5px 7px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    color: #fff;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .move_car_shuoming {
    margin-top: 40px;
    /*    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 0 10px;
    border-radius: 10px;
    background-color: #fff;
    padding: 10px;
    font-size: 15px;
    position: absolute;
    top: 45%; */
  }

  .move_car_title {
    /* margin: 10px 0;
    text-align: center;
    font-size: 20px; */
    display: flex;
    align-items: center;
  }

  .move_car_tipimg {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .move_car_tiptitle {
    font-size: 20px;
  }

  .move_car_tipp {
    font-size: 16px;
    margin-right: 15px;
  }

  .move_car_tipzhu {
    color: red;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/moveCar.vue